import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";

const UserTypeSelection = ({ onUserTypeSelect, userType, onBack }) => {
  const handleUserTypeSelect = (type) => {
    onUserTypeSelect(type);
  };

  return (
    <div className="text-center">
      <h3 className="mb-4">בחר את סוג המשתמש שלך</h3>
      <p className="text-muted mb-4">בחר את סוג החשבון שברצונך ליצור</p>

      <div className="mb-4">
        <h5 className="mb-3">סוג משתמש</h5>
        <Row className="justify-content-center g-3">
          {[
            {
              value: "manager",
              label: "מנהל ארגון/מועדון",
              description: "פתיחת ארגון חדש ב-SimplyCoach ופתיחת קבוצות.",
              icon: "💻",
            },
            {
              value: "coach",
              label: "מאמן",
              description: "הצטרפות לארגון קיים במערכת באמצעות קוד ארגון.",
              icon: "🏆",
            },
          ].map((option) => (
            <Col xs={10} md={5} key={option.value}>
              <Card
                onClick={() => handleUserTypeSelect(option.value)}
                className={`text-center p-3 option-card ${
                  userType === option.value ? "selected" : ""
                }`}
                style={{
                  cursor: "pointer",
                  borderRadius: "18px",
                }}
              >
                <Card.Body style={{ padding: 0 }}>
                  <div className="option-icon" aria-label="icon" role="img">
                    {option.icon}
                  </div>
                  <div className="fw-semibold fs-5">{option.label}</div>
                  <div
                    className={`mt-2 ${
                      userType === option.value ? "text-white" : "text-muted"
                    }`}
                    style={{ fontSize: "0.9rem" }}
                  >
                    {option.description}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </div>

      <div className="d-flex justify-content-between mt-4">
        <Button variant="outline-secondary" onClick={onBack}>
          חזור
        </Button>
        <Button
          variant="primary"
          size="lg"
          className="btn-block w-100"
          disabled={!userType}
          onClick={() => onUserTypeSelect("next")}
        >
          המשך
        </Button>
      </div>
    </div>
  );
};

export default UserTypeSelection;
